
const checkpointData = (state = [], action) => {
    if(action.type === 'SET_CHECKPOINT_DATA')
    {
        return [...state, action.payload];
    } else {
        return state;
    }
    
}

export default checkpointData;